<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <span class="btnPrivacy text-capitalize"  v-bind="attrs" v-on="on"> {{$t("privacyPoliciesTitle")}}</span>
        <!--v-icon v-bind="attrs" v-on="on">info</v-icon-->
      </template>
      <v-card>
        <v-card-title color="darkorange" >
          {{$t("privacyPoliciesTitle")}}
        </v-card-title>
        <v-card-text>
          {{$t("privacyPoliciesDescription")}}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" text @click="dialog = false">
            {{$t("accept")}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialog = false">
            {{$t("decline")}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
//component that displays the terms and conditions in a dialog
  export default {
    name: 'privacypolicies',
    data () {
      return {
        dialog: false,
      }
    }
  }
</script>
<style>
.btnPrivacy{
  text-transform:initial!important;
}
</style>